import status from "./status.action";
import search from "./search.action";
import review from "./review.action";
import suspend from "./suspend.action";
import schedule from "./schedule.action";
import sessions from "./sesssions.action";
import openSession from "./openSession.action";
import reviewModal from "./reviewModal.action";
import suspendModal from "./suspendModal.action";
import scheduleModal from "./scheduleModal.action";
import sessionsFilter from "./sessionsFIlter.action";
import upcommingSessions from "./upcommingSessions.action";

export default {
  upcommingSessions,
  sessionsFilter,
  scheduleModal,
  suspendModal,
  reviewModal,
  openSession,
  schedule,
  sessions,
  suspend,
  review,
  status,
  search,
};
